export const property_id = () => {
  return process.env.REACT_APP_PROPERTY_ID;
}
